import { useHttp } from '../http'

export const useAppStructureHttp = () => {

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`app-structures`, payload)
    }

    // The backend computes the hash from the uploaded bytes — nobody types one.
    const upload = <T>(payload: FormData): Promise<T> => {
        return useHttp().request('post', `app-structures/upload`, <any>payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    return {
        get,
        upload
    }
}
